import ReportBrandImageryGraphLevel2AndProgressionGraph from './reportBrandImageryGraphLevel2AndProgressionGraph'
export default ReportBrandImageryGraphLevel2AndProgressionGraph
